module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "l-section-full story-wrapper",
    attrs: {
      "id": "app-story"
    }
  }, [_c('ul', {
    staticClass: "c-tabmenu c-tabmenu_max-200"
  }, [_c('li', {
    staticClass: "c-tabmenu__item"
  }, [_c('router-link', {
    staticClass: "c-tabmenu__link",
    attrs: {
      "to": {
        name: 'intro'
      }
    }
  }, [_c('span', {
    staticClass: "c-tabmenu__text"
  }, [_vm._v("Introduction")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "c-tabmenu__item"
  }, [_c('router-link', {
    staticClass: "c-tabmenu__link",
    attrs: {
      "to": {
        name: 'story',
        params: {
          story: 'washio'
        }
      }
    }
  }, [_c('span', {
    staticClass: "c-tabmenu__text"
  }, [_vm._v("Washio Sumi Chapter")])])], 1), _vm._v(" "), (_vm.has_yusha) ? _c('li', {
    staticClass: "c-tabmenu__item"
  }, [_c('router-link', {
    staticClass: "c-tabmenu__link",
    attrs: {
      "to": {
        name: 'story',
        params: {
          story: 'yusha'
        }
      }
    }
  }, [_c('span', {
    staticClass: "c-tabmenu__text"
  }, [_vm._v("Hero Chapter")])])], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "p-v-transition-fade"
    }
  }, [(_vm.is_loading) ? _c('div', {
    staticClass: "p-loading p-loading_top-200 p-v-transition-fade"
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "p-v-transition-ud",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    attrs: {
      "is_loading": _vm.is_loading
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ad25089"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/story/story.vue
// module id = 55
// module chunks = 0